import trackTooltip, { horizontalPositionEnum, verticalPositionEnum } from '../lib/tracktooltip.js';

let exportTrackTooltip = trackTooltip;
exportTrackTooltip.horizontalPositionEnum = horizontalPositionEnum;
exportTrackTooltip.verticalPositionEnum = verticalPositionEnum;

export default exportTrackTooltip;
